/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { FunctionComponent,Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Row, Column, Button, Heading, cls } from '../../../packages/components';
import './_styles.scss';
import Translator from '../../../requests/apa/Translator';
import Assets from '../../../requests/apa/Asset';
import { LANDING } from '../../utils/constants';
import { LOGIN_EMAIL } from '../../../AAF/Auth/authConstants';
import {ButtonVariant} from '../../../packages/components/lib/Button';
import DeviceStorage  from '../../../components/DeviceStorage/DeviceStorage';
import LandingFlow from './LandingFlow';
import { MODAL_REGISTER_NET, showModal } from '../../../actions/modal';
import { connect } from 'react-redux';
import HistoryRegion from '../../../utils/HistoryRegion';
import Utils from '../../../utils/Utils';
import Device from '../../../devices/device';
import Image from '../../../components/Image/Image';
import { LABEL_REGISTRATE, LABEL_INICIA_SESION, LABEL_VER_GRATIS, COMPONENTE_LANDING, ACTIVAR_CODIGO_PROMOCIONAL, CLICK } from '../../utils/constansMetrics';
import { setMetricsEvent } from '../../../actions/metrics';
import { getUrlRedirectBack } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import { de } from 'date-fns/locale';


interface ILandingHeaderProps {
    /**
     * * url to show the image un landing's header.
     */
    image?: string;
}

const LandingHeader: FunctionComponent<ILandingHeaderProps> = (props) => {
    const { image } = props;
    return (
        <Grid>
            <Row>
                <Column lg={12} className={cls(`${LANDING}-logo`, `${LANDING}-content-center`)}>
                    <Image src={image} alt="ClaroVideo logo"/>
                </Column>
            </Row>
        </Grid>
    );
};

interface ILandingLabelsProps {
    /**
     * first text to show in white colour.
     */
    firstText?: string;
    /**
     * * second text to show in gray colour.
     */
    secondText?: string;
}

const LandingLabels: FunctionComponent<ILandingLabelsProps> = (props) => {
    const { firstText = null, secondText = null} = props;
    return (
        <Grid>
            <Row>
                {firstText && <Column lg={12} className={cls(`${LANDING}-content-center`)}>
                    <Heading size={1} className={cls(`${LANDING}-title`)}>
                        {firstText}
                    </Heading>
                </Column>
                }
                {secondText && <Column lg={12} className={cls(`${LANDING}-content-center`)}>
                    <Heading size={2} className={cls(`${LANDING}-subtitle`)}>
                        {secondText}
                    </Heading>
                </Column>
                }
            </Row>
        </Grid>
    );
};

interface ILandingButttonsProps {
    /**
     * Text to show in login's button.
     */
    text: string;
    /**
     * Cb to execute.
     */
    onClick?: () => void;
      /**
     * variant.
     */
    variant?: ButtonVariant;
    /**
     * valid device.
     */
    device: string;
}

interface ILandingButttonsPropsCode {
    caption: string;
    text: string;
    onClick?: () => void;
    variant?: ButtonVariant;
}

interface ILandingProps {
    linksNav?: any;
    element: JSX.Element[] | JSX.Element;
    showModal: (props: object) => void;
}


const LandingButtton: FunctionComponent<ILandingButttonsProps> = (props) => {
    const { text = '', onClick, variant = 'info', device} = props;
    return (
        <Grid>
            <Row>
                <Column
                    lg={12}
                    className={cls(`${LANDING}-buttons-up`, `${LANDING}-content-center`)}>
                    <Button
                        activate
                        type="button"
                        variant={variant}
                        className={cls(`focusable`,
                          `${LANDING}-button-login`)}
                        onClick={onClick}>
                        {text}
                    </Button>
                </Column>
            </Row>
        </Grid>
    );
};

const LandingButttonCode: FunctionComponent<ILandingButttonsPropsCode> = (props) => {
    const { text = '', caption ='', onClick, variant = 'info'} = props;
    return (
        <Grid>
            <Row className={cls(`${LANDING}-grid-code`)}>
                <Column
                    offset={3}
                    lg={3}
                    className={cls(`${LANDING}-content-center`, `${LANDING}-content-code-right`)}>
                    <Heading size={3} className={cls(`${LANDING}-caption-code`)}>
                        {caption}
                    </Heading>
                </Column>
                <Column
                    lg={3}
                    className={cls(`${LANDING}-buttons-up`, `${LANDING}-content-center`, `${LANDING}-content-code-left`)}>
                    <Button
                        type="button"
                        variant={variant}
                        className={cls(`focusable`, `${LANDING}-button-code`)}
                        onClick={onClick}>
                        {text}
                    </Button>
                </Column>
            </Row>
        </Grid>
    );
};

class Landing extends Component<RouteComponentProps & ILandingProps, {}> {
  constructor(props:RouteComponentProps & ILandingProps) {
    super(props);
    this.state = {
      componentReady: false
    };
  }
    logoUrl: string = Assets.get('claro_logo_red_white_medium', '');
    logoMetadata: string = Assets.get('landing_head_logoClarovideo', this.logoUrl);
    backbragound = '/images/landing-bg.png';
    backgroundMetadata: string = Assets.get('landing_access_background', this.backbragound);
    isBrasil: boolean = DeviceStorage.getItem('region') === 'brasil';
    styleBackground: object = {
        backgroundImage: `url(${this.backgroundMetadata})`
    };
    device = Device.getDevice().getPlatform();

    firstLabel: string = Translator.get('landing_menu_title_label', '¡Todo lo que te gusta en un sólo lugar!');
    secondLabel: string = Translator.get('landing_menu_description_label','El mejor contenido, canales de TV, películas y series.');

    /******************* REGISTRO *******************/
    textRegister: string  = Translator.get('landing_menu_option_button_register', 'REGÍSTRATE');
    goToRegister = () => {
        const { history } = this.props;
        history.push(HistoryRegion.goUrlRegister());
        Utils.sendMetric(this.props, CLICK,  LABEL_REGISTRATE, COMPONENTE_LANDING);
    };
    variantRegister:ButtonVariant = 'primary';


    /******************* LOGIN *******************/
    textLogin: string  = Translator.get('landing_menu_option_button_login', 'INICIA SESIÓN');
    goToLogin = () => {
        HistoryRegion.getUrlLogin(MODAL_REGISTER_NET, this.props )
        Utils.sendMetric(this.props, CLICK,  LABEL_INICIA_SESION, COMPONENTE_LANDING);
    };
    variantLogin:ButtonVariant = 'purple';

    /******************* LOGIN *******************/
    textSeenFree: string  = Translator.get('landing_menu_option_button_anonymous', null);
    getUrlRedirectSeeFree(defaultUrl:string) {
      const urlRedirect = getUrlRedirectBack('node/'+defaultUrl);
      this.props.history.push(urlRedirect);
    }

    goToSeenFree = () => {
        LandingFlow.setFlag(true);
        const { history } = this.props;
        history && this.props.linksNav && this.props.linksNav.hasOwnProperty('home') &&  this.getUrlRedirectSeeFree(this.props.linksNav.home);
        Utils.sendMetric(this.props, CLICK,  LABEL_VER_GRATIS, COMPONENTE_LANDING);
    };
    variantSeenFree:ButtonVariant = 'dark';

    /******************* CODIGO PRPMOCIONAL *******************/
    labelCode: string = Translator.get('landing_menu_promotionalCode_label', null);
    textCode: string = Translator.get('landing_menu_option_button_promotionalCode', null);
    goToCode = () => {
        Utils.sendMetric(this.props, CLICK,  ACTIVAR_CODIGO_PROMOCIONAL, COMPONENTE_LANDING);
    };

    componentDidMount = () => {
        const temp: any = window;
        temp.SpatialNavigation.focus();
        this.setState({componentReady: true});
    };

    goToRegisterNet(type: string){
        const { history} = this.props;
        history.push({
            pathname: '/login',
            typeRegisterNet: type
          })
    }

    render() {
        return (
            <div className={LANDING} style={this.styleBackground}>
                <div className={cls(`${LANDING}-relative`)}>
                    <div className={cls(`${LANDING}-center`)}>
                        {this.state.componentReady && (<LandingHeader image={this.logoMetadata} />)}
                        <LandingLabels firstText={this.firstLabel} secondText={this.secondLabel} />
                        <LandingButtton text = {this.textRegister} onClick={this.goToRegister} variant={this.variantRegister} device = {this.device}/>
                        <LandingButtton text = {this.textLogin} onClick={this.goToLogin} variant={this.variantLogin} device = {this.device}/>
                        {this.textSeenFree !== null && <LandingButtton text = {this.textSeenFree} onClick={this.goToSeenFree} variant={this.variantSeenFree} device = {this.device}/>}
                        {this.labelCode !== null && this.textCode !== null && <LandingButttonCode caption={this.labelCode} text = {this.textCode}  onClick={this.goToCode} variant={this.variantSeenFree}/>}
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = { showModal, setMetricsEvent };
export default connect(null, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/authentication/components/Landing/index.tsx